<template>
    <div class="no-drag-image" :style="frameStyle" :class="frameClass">
        <img :src="src" draggable="false" v-on:load="onLoad" ref="image" :class="isLoaded ? 'img-loaded' : ''" />
    </div>
</template>

<script>
    export default {
        name: 'no-drag-image',
        props: {
            src: {
                // example @/assets/logo.png
                type: String
            },
            scale: {
                default: 1
            },
            frameWidth: {
                type: String,
                default: ''
            },
            frameHeight: {
                type: String,
                default: ''
            },
            frameCrop: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                isLoaded: false,
            };
        },
        methods: {
            onLoad() {
                let scale = this.scale;

                if (scale === 'none') {
                    let image = this.$refs.image || null;

                    this.isLoaded = true;
                    this.$emit('load', image);

                    return;
                } else if (scale === 'fit' || scale === 'fitWidth' || scale === 'fitHeight') {
                    let image = this.$refs.image || null;

                    if (scale === 'fit') {
                        image.style.width = '100%';
                        image.style.height = '100%';
                    } else if (scale === 'fitWidth') {
                        image.style.maxWidth = '100%';
                    } else if (scale === 'fitHeight') {
                        image.style.maxHeight = '100%';
                    }

                    this.isLoaded = true;
                    this.$emit('load', image);

                    return;
                }

                if (scale === 'normal') {
                    scale = .7;
                } else if (scale === 'small') {
                    scale = .6;
                }

                if (typeof(scale) !== 'number') {
                    scale = parseFloat(scale);
                }

                if (!scale) {
                    scale = 1;
                }

                let image = this.$refs.image || null;

                if (image && scale !== 1) {
                    let currentWidth = image.naturalWidth;
                    let currentHeight = image.naturalHeight;

                    image.style.width = (currentWidth * scale) + 'px';
                    image.style.height = (currentHeight * scale) + 'px';
                }

                this.isLoaded = true;
                this.$emit('load', image);
            }
        },
        computed: {
            frameStyle() {
                let style = {};

                if (this.frameWidth) {
                    style.width = this.frameWidth;
                }

                if (this.frameHeight) {
                    style.height = this.frameHeight;
                }

                return style;
            },
            frameClass() {
                let classes = [];

                if (this.frameCrop === 'x') {
                    classes.push('no-drag-image-crop-x');
                } else if (this.frameCrop === 'y') {
                    classes.push('no-drag-image-crop-y');
                }

                return classes;
            }
        }
    }
</script>

<style scoped lang="scss">
    .no-drag-image {
        display: inline-block;
        width: auto;
        height: auto;
        padding: 0;
        overflow: hidden;

        &.no-drag-image-crop-y {
            img {
                max-height: 100%;
            }
        }

        &.no-drag-image-crop-x {
            img {
                max-width: 100%;
            }
        }
    }

    img {
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -o-user-select: none;
        user-select: none;

        /* This stops dragging in chrome */
        -webkit-user-drag: none;

        opacity: 0;

        &.img-loaded {
            opacity: 1;
        }
    }
</style>
